exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper[data-v-715fa764]{overflow:hidden!important;height:100%!important;padding-bottom:0!important}.active-conversation[data-v-715fa764]{background:linear-gradient(90deg,#000,#000 0,transparent 97%,transparent 0);border-radius:7px}", ""]);

// exports
